/* eslint-disable react/prop-types */
import React from "react";
import { updateCallback } from "../../../hooks/update-hooks/update-callbacks/update-callback";
import { toast } from "react-toastify";
function StatusDropdown({ callback, refetch }) {

    const [selctedStatus, setSelctedStatus] = React.useState(callback.status);
    const changeStatus = async (e) => {

        setSelctedStatus(e.currentTarget.value);
        callback.status = e.currentTarget.value;
        try {
            await updateCallback({
                status: e.currentTarget.value
            }, parseInt(callback.id))
            refetch()
        } catch (error) {
            toast.error(error)
        }

    }
    return (
        <select className="bg-white-50 rounded-md w-[120px] h-10 font-medium" onChange={(e) => changeStatus(e)} value={selctedStatus} name="status" id="status">
            <option value="NEW" >New</option>
            <option value="CALLBACK">Callback</option>
            <option value="NO_ANSWER">No Answer</option>
            <option value="BYPASSED">Bypassed</option>
            <option value="LOST">Lost</option>
            <option value="WARM">Warm</option>
            <option value="CONVERTED">Converted</option>
        </select>
    );


}

export { StatusDropdown };